import { useEffect } from 'react'
import styled from 'styled-components'

import { Layout, Text } from '@loadsmart/miranda-react'

import { RequestStatus } from 'core/domain/Request'
import { useAbortController } from 'core/ui/hooks/useAbortController'

import { analytics } from '../../core/utils/analytics'
import { useSpotQuoteList } from '../hooks/useSpotQuoteList'
import { SpotQuoteCard } from './SpotQuoteCard'
import { SpotQuoteListRefreshBanner } from './SpotQuoteListRefreshBanner'

const StyledSection = styled(Layout.Stack)`
  padding: 0 24px 18px 24px;
`

export function SpotQuoteList() {
  const abortController = useAbortController()
  const { spotQuoteList, spotQuoteListStatus, fetchSpotQuoteList } = useSpotQuoteList()

  const hasError = spotQuoteListStatus === RequestStatus.Error

  useEffect(() => {
    fetchSpotQuoteList(abortController)
  }, [abortController, fetchSpotQuoteList])

  useEffect(() => {
    if (spotQuoteList) {
      analytics.track('Loaded: Command Center', {
        number_of_entities: spotQuoteList.length,
        page_name: 'Bids',
      })
    }
  }, [spotQuoteList])

  if (hasError) return <SpotQuoteListRefreshBanner onRefreshList={fetchSpotQuoteList} />

  if (!spotQuoteList || spotQuoteList.length === 0) return null

  return (
    <StyledSection gap="spacing-4">
      <Layout.Stack gap="spacing-2">
        <Text variant="heading-md-bold">Invitation to bid</Text>
        <Text variant="heading-sm">Spot lanes waiting for your bid</Text>
      </Layout.Stack>
      {spotQuoteList.map(item => (
        <SpotQuoteCard item={item} key={item.lanes.uuid} />
      ))}
    </StyledSection>
  )
}
